import { watch } from 'vue'
import i18n from '../i18n'
import { getErrorMessage, getFieldErrors, localizeErrorMessage } from '../utils/userErrors'

export function getInputValidationMessage(input) {
  const validity = input.validity
  if (!validity) return ''
  const t = (key, params) => i18n.global.t(`errors.${key}`, params || {})
  if (validity.valueMissing) return t('required')
  if (validity.typeMismatch) return t(input.type === 'email' ? 'email' : 'url')
  if (validity.badInput) return t('number')
  if (validity.tooShort) return t('minLength', { count: input.minLength })
  if (validity.tooLong) return t('maxLength', { count: input.maxLength })
  if (validity.rangeUnderflow) return t('minValue', { count: input.min })
  if (validity.rangeOverflow) return t('maxValue', { count: input.max })
  if (validity.stepMismatch) return t('step', { count: input.step })
  if (validity.patternMismatch) return t('pattern')
  return t('invalid')
}

export default {
  install(app) {
    app.config.globalProperties.$apiError = getErrorMessage
    app.config.globalProperties.$fieldErrors = getFieldErrors
    app.config.globalProperties.$errorMessage = localizeErrorMessage

    // Native browser validation uses the selected app language as well.
    const managed = new WeakSet()
    const invalid = event => {
      const input = event.target
      if (typeof input.setCustomValidity !== 'function') return
      if (input.validity.customError && !managed.has(input)) return
      if (managed.has(input)) input.setCustomValidity('')
      if (!input.validity.valid) {
        input.setCustomValidity(getInputValidationMessage(input))
        managed.add(input)
      }
    }
    const clear = event => {
      if (managed.has(event.target)) {
        event.target.setCustomValidity('')
        managed.delete(event.target)
      }
    }
    document.addEventListener('invalid', invalid, true)
    document.addEventListener('input', clear, true)
    document.addEventListener('change', clear, true)
    const stop = watch(i18n.global.locale, locale => {
      document.documentElement.lang = locale === 'kk' ? 'kk' : 'ru'
      document.querySelectorAll('input, select, textarea').forEach(input => {
        if (managed.has(input)) invalid({ target: input })
      })
    }, { immediate: true })
    const unmount = app.unmount.bind(app)
    app.unmount = () => {
      stop()
      document.removeEventListener('invalid', invalid, true)
      document.removeEventListener('input', clear, true)
      document.removeEventListener('change', clear, true)
      unmount()
    }
  }
}
